import React from 'react';
import type { PapiDeviation } from '@wix/da-papi-types';
import {
  BiData,
  ThumbClickCommentBiEvent,
  BiContextProvidedValue,
} from '@wix/da-bi/pkg/events';
import ThumbIconButton from '@wix/da-ds/pkg/thumbs/ThumbIconButton';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import { getDeviationResourceType, getDeviationUrl } from '../../../_helpers';
import { useTranslation } from 'react-i18next';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';

export interface Props {
  deviation: PapiDeviation;
  hasCommentedOn?: boolean;
  className?: string;
  iconShapeSize?: IconSize.MEDIUM | IconSize.SMALLER;
}

const CommentControl: React.FC<Props> = ({
  deviation,
  hasCommentedOn,
  className,
  iconShapeSize,
}) => {
  const { t } = useTranslation();
  const { showStats } = useOverlayContext(deviation);
  const count = deviation.stats?.comments ?? 0;
  return (
    <ThumbIconButton
      className={className}
      iconShapeSize={iconShapeSize}
      type="comment"
      isEngaged={hasCommentedOn}
      showStatValue={!!showStats && !(count === 0)}
      statValue={deviation.stats?.comments}
      aria-label={t('deviationview.overlay.a11y.comment', { count })}
      href={`${getDeviationUrl(deviation)}#comments`}
      biData={BiData<ThumbClickCommentBiEvent>({
        evid: 105,
        typeid: getDeviationResourceType(deviation),
        itemid: deviation.deviationId,
        creatorid: deviation.author?.useridUuid ?? '',
        sectionname: BiContextProvidedValue,
        sectionid: BiContextProvidedValue,
        section_typeid: BiContextProvidedValue,
        sectiontype: BiContextProvidedValue,
        sectionrank: BiContextProvidedValue,
        rank: BiContextProvidedValue,
        sort_type: BiContextProvidedValue,
        reason_shown: BiContextProvidedValue,
        widgetname: BiContextProvidedValue,
      })}
    />
  );
};
CommentControl.displayName = 'CommentControl';

export default CommentControl;
